// extracted by mini-css-extract-plugin
module.exports = {"redeemCodeTitle":"PaymentsPromoCode__redeemCodeTitle","redeemCodeArrow":"PaymentsPromoCode__redeemCodeArrow"};